/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $GetTarfRequestDetailResponse = {
    properties: {
        tarf: {
    type: 'TarfDetail',
},
    },
};